import React from "react";
import "./wantToKnowMore.scss";

//Imagens:
import ImgWantToKnowMore from "../../../../assets/example/wantToKnowMore.png";
import { useTranslation } from "react-i18next";

function WantMoreInformationI() {
  const { t } = useTranslation()
  return (
    <div className="container-want-to-know-more">
      <div className="img-want-to-know-more">
        <img src={ImgWantToKnowMore} alt="" />
      </div>
      <div className="texts-want-to-know-more">
        <h1>{t("suport.want_know_more.title")}</h1>
        <p>{t("suport.want_know_more.section_text")}</p>
      </div>
    </div>
  );
}

export default WantMoreInformationI;
